import _ from 'lodash';
import utils from 'lib/utils';
import config from 'config';

const { baseUrl } = config;

export const getContractDocumentData = async (params, accessToken?: string) => {
  try {
    const qs = utils.getQs(params);
    const url = `${baseUrl}/BioFuelRequirementOffers/api/Deal/GetContractDocumentData?${qs}`;
    const fetchOpts: any = { method: 'POST' };
    // When a share link is opened by a not-logged-in user, there is no session
    // token. Pass the access token from the URL so utils.fetch uses it as the
    // Authorization header while keeping the default headers (e.g. initiator).
    if (accessToken) {
      fetchOpts.accessToken = accessToken;
    }
    const res = await utils.fetch(url, fetchOpts).ready;
    const resData = await utils.processApiRes(res);
    return resData;
  } catch (err: any) {
    const errors = await utils.processApiErrors(err, '', 'GetContractDocumentData');
    throw errors;
  }
};
